import {
  parseEvaluationPlanSheetCanvasDocument,
  type EvaluationPlanSheetCanvasDocumentV1,
} from '../types/evaluationPlanSheetCanvas';

const STORAGE_PREFIX = 'cp:evaluation-plan-sheet-canvas-draft:v1:';

export function buildEvaluationPlanSheetCanvasDraftStorageKey(planKey: string): string {
  return `${STORAGE_PREFIX}${planKey.trim()}`;
}

export function loadEvaluationPlanSheetCanvasDraft(
  planKey: string
): EvaluationPlanSheetCanvasDocumentV1 | null {
  if (!planKey.trim()) return null;
  try {
    const raw = localStorage.getItem(buildEvaluationPlanSheetCanvasDraftStorageKey(planKey));
    if (!raw) return null;
    return parseEvaluationPlanSheetCanvasDocument(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function saveEvaluationPlanSheetCanvasDraft(
  planKey: string,
  document: EvaluationPlanSheetCanvasDocumentV1
): void {
  if (!planKey.trim()) return;
  try {
    localStorage.setItem(
      buildEvaluationPlanSheetCanvasDraftStorageKey(planKey),
      JSON.stringify(document)
    );
  } catch {
    /* localStorage quota — ignore */
  }
}

export function clearEvaluationPlanSheetCanvasDraft(planKey: string): void {
  if (!planKey.trim()) return;
  try {
    localStorage.removeItem(buildEvaluationPlanSheetCanvasDraftStorageKey(planKey));
  } catch {
    /* ignore */
  }
}
